import { GlobalStyle, ShowAllComponents, ShowSmallScreenMsg, SmallScreenHeading } from 'common/styles/globalStyles';
import { CityScape, Facility } from 'pages';
import Product from 'pages/Room/Products/Product';
import Room from 'pages/Room/Room';
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import store from 'store/store';

const App: React.FC = () => (
  <Provider store={store}>
    <GlobalStyle />
    <ShowSmallScreenMsg>
      <SmallScreenHeading>This is a small screen.</SmallScreenHeading>
      Please use a larger screen to see the full content.
    </ShowSmallScreenMsg>

    <ShowAllComponents>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={CityScape} />
          <Route exact path="/:facility" component={Facility} />
          <Route exact path="/:facility/:room" component={Room} />
          <Route exact path="/:facility/:room/:product" component={Product} />
        </Switch>
      </BrowserRouter>
    </ShowAllComponents>
  </Provider>
);

export default App;
